import React from 'react';
import moment from 'moment';
import RangePicker from '@/pages/home/components/RangePicker';
import RangeDayMonthSelector from '@/pages/dashboard/components/RangeDayMonthSelector';
import TimePicker from '@/pages/dashboard/components/TimePicker';
import SelectorMultiple from '@/pages/dashboard/components/SelectorMultiple';
import RegionSelector from '@/pages/dashboard/components/RegionSelector';
import { formatNetworkOptions, formatOptions, formatRegionOptions, formatRegionSingleSelectOptions, buildSystemCascadeProps } from '../util';
import { LANGUAGE_CN, LANGUAGE_EN, PUBG_GAME_CODE_LIST } from '@/pages/dashboard/_config/constant';
import NewSelectorMultiple from '../../NewSelectorMultiple';
import {
  RANGE_DAILY,
  RANGE_WEEKLY,
  RANGE_MONTHLY,
  RANGE_DATE,
  RANGE_DAY_MONTH,
  SINGLE_DAILY,
  CONTRAST_DAILY,
  CHANNEL,
  LANGUAGE,
  REGION,
  SYSTEM,
  ZONE,
  RANGE_DAILY_TYPE,
  RANGE_WEEKLY_TYPE,
  RANTE_TYPE,
  RANGE_MONTHLY_TYPE,
  NETWORK_TYPE,
  MEDIA_CHANNEL,
  BUNDLE,
  CONTRAST_DAILY2,
} from './_config';
import { START_OF_DATE } from '@/pages/dashboard/utils/_config/constant';
import { getExtraShortcut } from './getExtraShortcut';
import RangePickerLeft from '../../RangePickerLeft';
import renderCustom from './RenderCustomSelect';
import classNames from 'classnames';
import { getRealtimeCcuContrastFilterClass } from '../../Filter/FilterBase/_config/constant';
import CommonBubble from '@home/components/CommonBubble';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';
import { getLanguage } from '@home/utils/common';
import { getRangeTimeLimitMsg } from '@/pages/dashboard/utils/utils';
import CountryFilter from '@/pages/benchmark/components/CountryFilter';
import "../index.scss";

const START_OF_WEEK = 1;

const renderRangeDate = (props: any) => {
  const { value, componentDefault, type, key = 'date', onlyValue = true, showSelectType = true, typeList, startOfDate,
    latestDate, locale, onChange, dispatch, isReseted, setShortcutOption, seasonInfo, overRangeTimeLimit, gameCode,
    hideEventTab, hideLatestData, customShortcuts, ...restProps } = props || {};
  const startOfTime = startOfDate || START_OF_DATE;
  const isEn = locale === LANGUAGE_EN;
  const rangeTimeLimitMsg = getRangeTimeLimitMsg(gameCode);
  const shortcutLatestDate = hideLatestData ? {} : latestDate;

  return (
    <CommonBubble
      visible={overRangeTimeLimit}
      placement="top"
      style={{ maxWidth: "365px" }}
      content={<FormatHtmlTextToReact text={getLanguage(isEn, rangeTimeLimitMsg.en, rangeTimeLimitMsg.cn)} />}
      error
      escapeWithReference
      flipped={false}
      destroyOnClose={false}
      popupContainer={() => document.querySelector(".search-item-date") as HTMLElement}
    >
      <div
        className={classNames(
          'search-item',
          'search-item-date',
          'dbd-range-picker',
          { 'dbd-range-picker-error': overRangeTimeLimit }
        )}
        key={key}
      >
        <RangePicker
          type={type}
          latestDate={shortcutLatestDate}
          value={value}
          startOfTime={startOfTime}
          // setShortcutOption={setShortcutOption || (()=>{
          //   const result = shortcutOptionDefualt(startOfTime,latestDate,seasonInfo, dispatch)
          //   console.log('result',result)
          //   return result
          // })}
          setShortcutOption={() => (
            <RangePickerLeft
              latestDate={shortcutLatestDate}
              startOfTime={startOfTime}
              seasonInfo={seasonInfo}
              hideEventTab={hideEventTab}
              customShortcuts={customShortcuts}
            />
          )}
          className="search-border"
          overlayClassName='dbd-range-picker-overlay'
          typeList={typeList}
          showSelectType={showSelectType}
          startOfWeek={START_OF_WEEK}
          language={locale === LANGUAGE_CN ? 'cn' : 'en'}
          onChange={(value: any, type: string) => {
            onChange(key, onlyValue ? value : {
              value,
              type
            });
          }}
          isReseted={isReseted}
          {...restProps}
          defaultValue={componentDefault}
          extraShortcut={hideEventTab ? undefined : getExtraShortcut(seasonInfo)}
        />
      </div>
    </CommonBubble>
  );
};

// 日
const renderRangeDaily = (props: any) => {
  const { key, value, latestDate, locale, onChange, ...restProps } = props || {};
  return renderRangeDate({
    key,
    value,
    type: 'date',
    latestDate,
    typeList: RANGE_DAILY_TYPE,
    showSelectType: false,
    locale,
    onChange,
    ...restProps
  });
};

// 周
const renderRangeWeekly = (props: any) => {
  const { key, value, latestDate, locale, onChange, ...restProps } = props || {};
  return renderRangeDate({
    key,
    value,
    type: 'week',
    latestDate,
    typeList: RANGE_WEEKLY_TYPE,
    showSelectType: false,
    locale,
    onChange,
    ...restProps
  });
};

// 月
const renderRangeMonthly = (props: any) => {
  const { key, value, latestDate, locale, onChange, ...restProps } = props || {};
  return renderRangeDate({
    key,
    value,
    type: 'month',
    latestDate,
    typeList: RANGE_MONTHLY_TYPE,
    showSelectType: false,
    locale,
    onChange,
    ...restProps
  });
};

// 日周月
const renderRangeTypes = (props: any) => {
  const { key, value: propVal, defaultValue, latestDate, locale, onChange, isReseted, ...restProps } = props || {};
  const { type = 'date', value = null } = propVal || {};
  return renderRangeDate({
    key,
    value,
    defaultValue,
    type,
    latestDate,
    typeList: RANTE_TYPE,
    showSelectType: true,
    onlyValue: false,
    locale,
    onChange,
    isReseted,
    ...restProps
  });
};

const renderRangeDayMonth = (props: any) => {
  const { key, value, defaultValue, onChange, ...restProps } = props || {};
  return <RangeDayMonthSelector
    matchButtonWidth
    className={`search-item`}
    value={value}
    defaultValue={defaultValue}
    onConfirm={(value) => {
      onChange(key, value);
    }}
    {...restProps}
  />;
};

// 区服
const renderZone = (props: any) => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};

  return <NewSelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    label={name || getLocalText('selector_multiple_component_zone_label', {}, false)}
    allDescribe={getLocalText('selector_multiple_component_zone_all_describe', {}, false)}
    allInfo={allInfo || getLocalText('selector_multiple_component_zone_all_info', {}, false)}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatOptions({
      options,
      locale,
      valueKey: 'zone_code',
      cnKey: 'zone_name_ch',
      enKey: 'zone_name_en'
    })}
    {...restProps}
  />;
};

// 平台
const renderSystem = (props: any) => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, allInfo, view_type, parentKey, childKey, ...restProps } = props || {};

  const toolTipText = getLocalText('selector_multiple_component_system_tips', {}, false);

  // 兜底判断选项是否有分类
  const hasType = options?.some((item: any) => !!item.type);

  // 级联筛选器：使用 CascadeFilterComponent（参考 ua_network 的处理方式）
  // 数据处理逻辑（选项映射、值转换、onChange 包装）统一在 util.ts 的 buildSystemCascadeProps 中处理
  if (view_type === 'cascade' && hasType) {
    const { cascadeOptions, cascadeValue, cascadeOnChange } = buildSystemCascadeProps({
      key, value, options, onChange, parentKey, childKey,
    });

    return renderCustom({
      ...props,
      options: cascadeOptions,
      value: cascadeValue,
      onChange: cascadeOnChange,
      parentKey,
      childKey,
      view_type: 'cascade',
      tooltip: toolTipText,
      className: "dbd-system-cascade"
    });
  }

  if (view_type === 'group' && hasType) {
    const group: any = {};
    options?.forEach((item: any) => {
      if (!group[item.type]) {
        group[item.type] = item.type;
      }
    });
    return renderCustom({ ...props, group, valueKey: 'os_id', cnKey: 'os_name_ch', enKey: 'os_name_en', tooltip: toolTipText, 
      // POE2 平台最长Official Website(Mac)
      matchButtonWidth: false, listWidth: 250  });
  }

  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips={true}
    tipsInfo={toolTipText}
    label={name || getLocalText('selector_multiple_component_system_label', {}, false)}
    allDescribe={getLocalText('selector_multiple_component_system_all_describe', {}, false)}
    allInfo={allInfo || getLocalText('selector_multiple_component_system_all_info', {}, false)}
    value={value}
    onChange={(value) => {
      onChange(key, value);
    }
    }
    options={formatOptions({
      options,
      locale,
      valueKey: 'os_id',
      cnKey: 'os_name_ch',
      enKey: 'os_name_en',
      iconKey: 'icon'
    })}
    {...restProps}

  />;
};


// 语言
const renderLanguage = (props: any) => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};

  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips={true}
    tipsInfo={getLocalText('selector_multiple_component_language_tips', {}, false)}
    label={name || getLocalText('selector_multiple_component_language_label', {}, false)}
    allDescribe={getLocalText('selector_multiple_component_language_all_describe', {}, false)}
    allInfo={allInfo || getLocalText('selector_multiple_component_language_all_info', {}, false)}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatOptions({
      options,
      locale,
      valueKey: 'lang_code',
      cnKey: 'lang_name_ch',
      enKey: 'lang_name_en',
    })}
    {...restProps}
  />;
};

// bundle
const renderBundle = (props: any) => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};
  const bundleInfoStr = locale === LANGUAGE_EN ? `${name}s` : name;
  return <NewSelectorMultiple
    matchButtonWidth
    className='search-item dbd-bubddle-search-item'
    key={key}
    label={name || getLocalText('selector_multiple_component_bundle_label', {}, false)}
    allDescribe={getLocalText('selector_multiple_component_common_all_describe', {}, false)}
    allInfo={allInfo || getLocalText('selector_multiple_component_common_all_info', { name: bundleInfoStr }, false)}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatOptions({
      options,
      locale,
      valueKey: 'bundle_id',
      cnKey: 'bundle_name_ch',
      enKey: 'bundle_name_en'
    })}
    {...restProps}
  />;
};

// 渠道
const renderChannel = (props: any) => {
  const { gameCode, isPoeFunnel, isCasual, key, value, options, defaultValue, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};
  const isPUBGM = PUBG_GAME_CODE_LIST.includes(gameCode);
  // isPoeFunnel
  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    showTips={true}
    // isPoeFunnel
    tipsInfo={isPoeFunnel ? getLocalText('funnel_channel_tips_poe', {}, false) : isCasual ? getLocalText('selector_multiple_component_channel_tips_iaa', {}, false) : getLocalText('selector_multiple_component_channel_tips', {}, false)}
    label={name || (isPoeFunnel ? getLocalText('funnel_channel_poe', {}, false) : getLocalText('selector_multiple_component_channel_label', {}, false))}
    allDescribe={getLocalText('selector_multiple_component_channel_all_describe', {}, false)}
    allInfo={
      allInfo ||
      (isPoeFunnel ? getLocalText('funnel_channel_all_info_poe', {}, false) :
        isPUBGM ?
          <div className="text-multiple-line-wrap">{getLocalText('selector_multiple_component_channel_all_info_pubgm', {}, false)}</div> :
          getLocalText('selector_multiple_component_channel_all_info', {}, false))}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatOptions({
      options,
      locale,
      valueKey: 'channel_id',
      cnKey: 'channel_name_ch',
      enKey: 'channel_name_en'
    })}
    {...restProps}
  />;
};

// 国家
const renderRegion = (props: any): React.ReactElement => {
  const { key, value, options, onChange, locale, getLocalText, name, allInfo, lftName, rtName, view_type, ...restProps } = props || {};
  const language = {
    en: {
      'button_region': name || 'Region',
      'button_market': lftName || 'Country/Market',
      'region_title': rtName || 'Region',
    },
    cn: {
      'button_region': name || '区域',
      'button_market': lftName || '国家/市场',
      'region_title': rtName || '区域',
    }
  };
  // 国家单选筛选器
  if (view_type === 'singleCascade') {
    const group: any = {};
    options?.forEach((item: any) => {
      if (!group[item.type]) {
        group[item.type] = item.type;
      }
    });
    return <CountryFilter
      nameEN="Region/Country"
      nameCN="区域/国家"
      filterKey={key}
      className="search-item"
      options={formatRegionSingleSelectOptions(options)}
      value={value?.markets?.[0] === "255" ? 'global' : value?.markets?.[0]}
      onChange={(filterKey, value) => {
        // 将单个值转换为RegionSelector的格式
        const selectedValue = value==='global' ? "255" : value;
        console.log('selectedValue',selectedValue);
        onChange(filterKey, {
          regions: [],
          markets: [selectedValue],
          region_type: 'market'
        });
      }}
      {...restProps}
    />;
  }

  return <RegionSelector
    language={language}
    matchButtonWidth
    key={key}
    className={'search-items-country js-search-items-country'}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    locale={locale}
    // popularList={popularList}，// 在restProps里面
    globalMessageHidden={false}
    globalMsg={allInfo || getLocalText('region_selector_global_message', {}, false)}
    regionCountry={formatRegionOptions(options)}
    // {...(value?.otherConfig || {})}
    {...restProps}
  />;
};

// 网络类型
const renderNetworkType = (props: any) => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};
  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    label={name || getLocalText('selector_multiple_component_network_label', {}, false)}
    allDescribe={getLocalText('selector_multiple_component_network_all_describe', {}, false)}
    allInfo={allInfo || getLocalText('selector_multiple_component_network_all_info', {}, false)}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatNetworkOptions({
      options
    })}
    {...restProps}
  />;
};


// 媒体渠道
const renderMediaChannel = (props: any) => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};
  return <SelectorMultiple
    matchButtonWidth
    className='search-item'
    key={key}
    label={name || getLocalText('selector_multiple_component_media_label', {}, false)}
    allDescribe={getLocalText('selector_multiple_component_media_all_describe', {}, false)}
    allInfo={allInfo || getLocalText('selector_multiple_component_media_all_info', {}, false)}
    value={value}
    onChange={(value) => { onChange(key, value) }}
    options={formatOptions({
      options,
      locale,
      valueKey: 'channel_id',
      cnKey: 'channel_name_ch',
      enKey: 'channel_name_en',
      iconKey: 'icon'
    })}
    {...restProps}
  />;
};

const renderSingleTime = (props: any) => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, ...restProps } = props || {};
  return <TimePicker
    matchButtonWidth
    className={`search-item dtb-timepicker-input-prefix ${locale === 'zh-CN' ? 'dtb-language-cn' : ''}`}
    comKey={key}
    locale={locale}
    onConfirm={(val: any) => {
      onChange(key, moment(val).format('YYYY-MM-DD'));
    }}
    defaultValue={defaultValue}
    value={value}
    {...restProps}
  />;
};

const renderContrastDay = (props: any) => {
  const { alias, key, value, defaultValue, onChange, locale, getLocalText, ...restProps } = props || {};

  return (
    <TimePicker
      matchButtonWidth
      className={classNames(
        `search-item`,
        `dtb-datepicker-input-prefix${getRealtimeCcuContrastFilterClass(alias)}`,
        `js-realtime-datepicker`,
        {
          [`dtb-language-cn`]: locale === 'zh-CN',
        }
      )}
      comKey={key}
      locale={locale}
      onConfirm={(val: any) => onChange(key, moment(val).format('YYYY-MM-DD'))}
      defaultValue={defaultValue}
      value={value}
      titleName={getLocalText('filter_contrast')}
      {...restProps}
    />
  );
};


export default {
  [RANGE_DAILY]: renderRangeDaily,
  [RANGE_WEEKLY]: renderRangeWeekly,
  [RANGE_MONTHLY]: renderRangeMonthly,
  [RANGE_DATE]: renderRangeTypes,
  [RANGE_DAY_MONTH]: renderRangeDayMonth,
  [ZONE]: renderZone,
  [SYSTEM]: renderSystem,
  [LANGUAGE]: renderLanguage,
  [BUNDLE]: renderBundle,
  [CHANNEL]: renderChannel,
  [REGION]: renderRegion,
  [NETWORK_TYPE]: renderNetworkType,
  [MEDIA_CHANNEL]: renderMediaChannel,
  [SINGLE_DAILY]: renderSingleTime,
  [CONTRAST_DAILY]: renderContrastDay,
  [CONTRAST_DAILY2]: renderContrastDay,
};
